<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-va-optimization-line-chart">
    <!-- <div class="view-by">By {{this.type}}</div> -->
    <div ref="chart" class="metrics-chart" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default Vue.extend({
  name: 'wy-va-optimization-line-chart',
  props: ['data', 'type'],

  data() {
    return {
      lineColor: '#1C4DB2',
      showNluMetric: false,
      showFalsePositiveMetric: false,
      showMsgNotUnderstoodMetric: false,
      showLowQualityIntentsMetric:false
    }
  },

  computed: {
    ...mapGetters(['dataModel','companyConfig', 'legendDefaultColors']),
  },

  methods: {
    prepareDataSet(title, dateList, valueList, color) {
      let chartValueList = [];
      if(valueList && valueList.length > 0) {
        valueList.forEach(value => {
          if(value >= 0) {
            chartValueList.push(value + '%')
          }
          else {
            chartValueList.push('N/A'); // if value is -1, return 'N/A'
          }
        });
      }
      let dateset = {
        name: title,
        type: "scatter",
        mode: chartValueList.length > 1 ? "lines" : "lines+markers",
        cliponaxis: false,
        marker: {size: 8},
        line: {
          color: color,
          width: 1
        },
        hoverlabel: {
          namelength: 50,
          font: {
            size: 11,
            color: 'white'
          },
          bordercolor: color,
        },
        x: dateList,
        y: valueList,
        hovertext: chartValueList,
        hovertemplate: "%{hovertext}<extra></extra>" //this.wyChart.hoverTemplateNoDate("d"),
      };

      return dateset;
    },
    
    buildChart(dataList) {
      if(this.$refs.chart && dataList) {
        let traces = [];
        let legendOriginColors = [];
        if(this.companyConfig && this.companyConfig.legends && this.companyConfig.legends.legendColors && this.companyConfig.legends.legendColors.length > 0) {
            legendOriginColors = _.uniq(_.concat(this.companyConfig.legends.legendColors, this.legendDefaultColors));
          }
          else {
            legendOriginColors = this.legendDefaultColors
          }
        if(dataList.understandingList) {
          let botOnlyContainedDataset = this.prepareDataSet("NLU", dataList.dateList, dataList.understandingList, legendOriginColors[0]);
          let botOnlyEscalatedDataset = this.prepareDataSet("VA Conversations Contained", dataList.dateList, dataList.containmentList, legendOriginColors[1]);
          let botToLCOnlyDataset = this.prepareDataSet("Negative Feedback Score", dataList.dateList, dataList.negativeFeedbackScoreList, legendOriginColors[2]);
          // lCOnlyListDataset = this.prepareDataSet("Journey Completion", dataList.dateList, dataList.engagementList, "#B261CE");
          traces = [botOnlyContainedDataset, botOnlyEscalatedDataset, botToLCOnlyDataset];
        }
        else {
          let nluDataset = this.prepareDataSet("NLU", dataList.dateList, dataList.nluList, legendOriginColors[0]);
          let falsePositivesDataset = this.prepareDataSet("False Positives", dataList.dateList, dataList.falsePositivesList, legendOriginColors[1]);
          let notUnderstoodDataset = this.prepareDataSet("Messages Not Understood", dataList.dateList, dataList.messagesNotUnderstoodList, legendOriginColors[2]);
          let lowQulityDataset = this.prepareDataSet("Low-Quality Intents", dataList.dateList, dataList.lowQualityIntentsList, legendOriginColors[3]);

          if(this.showNluMetric) traces.push(nluDataset);
          if(this.showFalsePositiveMetric) traces.push(falsePositivesDataset);
          if(this.showMsgNotUnderstoodMetric) traces.push(notUnderstoodDataset);
          if(this.showLowQualityIntentsMetric) traces.push(lowQulityDataset);
        }

        traces.forEach(trace => {
          let hasData = false;
          let noDataTrace = [];
          trace.y.forEach((item) => {
            if(item == -1) {
              noDataTrace.push(null);
            }
            else {
              hasData = true;
            }
          })
          if(!hasData) {
            trace.y = noDataTrace;
            trace.line.color = "#c9d3da";
            trace.disableLegend = true;
            let name = trace.name;
            trace.name = "<span style='color:#c9d3da'>"+ name + "</span>"
          }
        })
        // Hide "Journey Completion" base on OC-388 request
        // let traces = [botOnlyContainedDataset, botOnlyEscalatedDataset, botToLCOnlyDataset, lCOnlyListDataset];
        // let traces = [botOnlyContainedDataset, botOnlyEscalatedDataset, botToLCOnlyDataset];
        traces.forEach(trace => {
          let colors = [];
          trace.x.forEach(() => {
            colors.push('transparent');
          });
          trace.marker = {color: colors, size: 8}
        })
        let layout = {
          autosize: true,
          height: 290,          
          dragmode: false, //'pan'
          separators: '.',
          showlegend: true,
          plot_bgcolor: 'white',
          // hoverlabel: {
          //   namelength: 50,
          //   font: {
          //     size: 11
          //   },
          //   bordercolor: '#FCFEFF'
          // },
          legend: {
            orientation: 'h',
            x: 0.15,
            // x: -0.02,
            y: -0.25,
            bgcolor: 'rgba(0,0,0,0)',
            // xanchor: 'center'
            //itemwidth: 50
          },
          margin: { l: 70, r: 50, t: 20, b: 40 },
          xaxis:  {
            type: 'date',
            // tickformat: '%b %d %Y',
            tickformat: '%b %d',
            nticks: (dataList.dateList.length > 9 ? 0 : dataList.dateList.length),
            autorange: true,
            showgrid: false,
            zeroline: true,
            automargin: true,
            showline: true,
            linecolor: '#dedede',
            position: 0,
            tickcolor: "transparent",
            title: {
              font: {
                size: 12
              }
            }
          },
          yaxis: {
            type: 'linear',
            autorange: true,
            //rangemode: 'tozero',
            side: 'right',
            separatethousands: true,
            ticksuffix: '%',
            showgrid: true,
            showline: true,
            zeroline: false,
            linecolor: '#dedede',
            layer: 'below traces',
            fixedrange: true,
          }
        }        

        let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false};
        // eslint-disable-next-line no-undef
        Plotly.newPlot(this.$refs.chart, traces, layout, config);
        let doms = document.querySelectorAll(".svg-container .legend .legendlines")
        doms.forEach((dom, index)=>{
          var svgns = "http://www.w3.org/2000/svg";
          var circle = document.createElementNS(svgns, 'circle');
          circle.setAttributeNS(null, 'cx', 21);
          circle.setAttributeNS(null, 'cy', 0);
          circle.setAttributeNS(null, 'r', 6);
          circle.setAttributeNS(null, 'fill', legendOriginColors[index]);
          dom.appendChild(circle);
        })
        this.$refs.chart.on('plotly_legendclick', function(data){
          let count = 0;
          data.data.forEach(item => {
            if(!item.disableLegend && (!item.visible || item.visible !='legendonly')) {
              count ++
            }
          })
          if(count > 1) {
            if(data.data[data.curveNumber].disableLegend) {
              return false
            }
          }
          else {
            if(!data.data[data.curveNumber].visible || data.data[data.curveNumber].visible != 'legendonly') {
              return false;
            }
          }
        })
        this.$refs.chart.on('plotly_hover', (data) => {          
          try {
            let dataPoint = data.points[0];
            if(dataPoint && dataPoint.data && dataPoint.data.marker) {              
              let pn = dataPoint.pointNumber;
              // let sizes = dataPoint.data.marker.size;
              // sizes[pn] = 8;
              // let update = {'marker': {size: sizes}};
              let colors = dataPoint.data.marker.color;
              colors[pn] = this.lineColor;
              // console.log(this.lineColor)
              let update = {'marker': {color: colors}};
              // eslint-disable-next-line no-undef
              Plotly.relayout(this.$refs.chart, update, 0);
            }
          }
          catch {
            // catch error
          }
        });

        // mouse out on point
        this.$refs.chart.on('plotly_unhover', (data) => {
          try {
            let dataPoint = data.points[0];
            if(dataPoint && dataPoint.data && dataPoint.data.marker) {
              let pn = dataPoint.pointNumber;
              // let sizes = dataPoint.data.marker.size;
              // sizes[pn] = 0;
              // let update = {'marker': {size: sizes}};
              let colors = dataPoint.data.marker.color;            
              colors[pn] = "transparent";
              let update = {'marker': {color: colors}};
              // eslint-disable-next-line no-undef
              Plotly.relayout(this.$refs.chart, update, 0);
            }
          }
          catch {
            // catch error
          }
        });
      }
    },

    resizeWindowHandler() {
      // eslint-disable-next-line no-undef
      if(this.$refs.chart) Plotly.relayout(this.$refs.chart, {});
      // var pathD = "M 26 0 h 1";
      // let doms = document.querySelectorAll(".svg-container .legend .legendlines path.js-line")
      // console.log("rendering......", doms)
      //   if(doms && doms.length>0) {
      //   setTimeout(()=>{
      //     doms.forEach(dom=>{
      //       dom.setAttribute("d", pathD);
      //       dom.style.display = 'block';
      //     })
      //   }, 400)
      // }
    },
  },
  mounted() {
    let nluIntentPerformancePageConfig = this.companyConfig ? ((this.companyConfig.appPages || {}).nluIntentPerformancePage || {}) : {};
    let metrics = nluIntentPerformancePageConfig.metrics || {};
    this.showNluMetric = metrics.nlu!=null ? metrics.nlu : true;
    this.showFalsePositiveMetric = metrics.falsePositive!=null ? metrics.falsePositive : true;
    this.showMsgNotUnderstoodMetric = metrics.notUnderstood!=null ? metrics.notUnderstood : true;
    this.showLowQualityIntentsMetric = metrics.lowQualityIntents!=null ? metrics.lowQualityIntents : true;

    setTimeout(() => {
      const resize_ob = new ResizeObserver(() => {
        this.resizeWindowHandler()
      });
      if(document.querySelector("wy-va-optimization")) {
        resize_ob.observe(document.querySelector(".wy-va-optimization"));
      }
      if(document.querySelector("wy-va-intent-performance")) {
        resize_ob.observe(document.querySelector(".wy-va-intent-performance"));
      }
    }, 300);  
  }
});
</script>

<style lang="scss">
.wy-va-optimization-line-chart {
  min-height: 200px;
  border-radius: 10px;
  background-color: transparent;
  padding: 20px 0 2px 0;
  margin-bottom: 10px;

  .view-by {
    text-align: right;
    padding-right: 20px;
    color: var(--site-font-tertiary-color);
    font-size: 14.22px;
  }

  .title {
    font-size: 21px;
    font-weight: 600;
    line-height: 0;
    margin-left: 25px;
    color: #0B284F;
    padding-bottom: 15px;
  }

  .metrics-chart {
    width: 100%;
    .svg-container .legend .legendlines path.js-line {
      stroke: transparent !important;
      stroke-width: 10px !important;
      stroke-linecap: round;
      d: path("M 20 0 h 1");
    }
    .legendtext {
      transform: translate(-3.04px, -1.25px) !important;
    }
  }
}
.wy-va-optimization-line-chart .js-plotly-plot .plotly .cursor-ew-resize {
  cursor: pointer !important;
}
</style>